// should match BE TOKEN_AUTHENTICATION_HEADER (flask-security setting)
export const TOKEN_AUTHENTICATION_HEADER = 'Authentication-Token';
// should match BE TOKEN_AUTHENTICATION_KEY (flask-security setting)
export const TOKEN_AUTHENTICATION_KEY = 'auth_token';
